<section class="grid gap-4">
  <div>
    <page-title [title]="'Employee imports'"></page-title>
  </div>

  <employee-import
    [busy]="employeeStore.importing()"
    [status]="employeeStore.importStatus()"
    [result]="employeeStore.importResult()"
    (retryRequested)="retryImport()"
    (imported)="importEmployees($event)" />

  <employee-imports-table
    [imports]="employeeStore.imports()"
    [loading]="employeeStore.importsLoading()"
    [pageNumber]="employeeStore.importsPageNumber()"
    [pageSize]="employeeStore.importsPageSize()"
    [totalCount]="employeeStore.importsTotalCount()"
    [totalPages]="employeeStore.importsTotalPages()"
    [downloadingImportId]="employeeStore.importDownloadId()"
    [downloadingErrorImportId]="employeeStore.importErrorDownloadId()"
    [downloadingSummaryImportId]="employeeStore.importSummaryDownloadId()"
    (refreshed)="refreshImports()"
    (pageChanged)="changePage($event)"
    (downloadRequested)="downloadImport($event)"
    (downloadErrorsRequested)="downloadImportErrors($event)"
    (downloadSummaryRequested)="downloadImportSummary($event)" />
</section>
